import { Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import type { ChartRendererProps } from '../types.ts';

/**
 * Renders a chart that is not yet implemented.
 */
export function UnsupportedChartRenderer({ config }: ChartRendererProps) {
  console.warn(`Chart type "${config.chartType}" has no registered renderer.`);
  return (
    <Alert color="yellow" icon={<IconInfoCircle size={16} />} variant="light">
      Chart type "{config.chartType}" is not supported.
    </Alert>
  );
}
